module.exports = "/_next/static/images/9f0babddc4234722fc5b20cc9f0a5751-qr-to-app-v1.svg.webp";